import * as actions from '../actions/contacts.actions';
import { getProfileId } from "../../services/profile.service";

const defaultState = {
  contacts: [],
  selectedContact: null,
  contactInvites: {
    received: [],
    sent: [],
  },
  errors: [],
};


const contactsReducer = (state = defaultState, action) => {
  switch (action.type) {
    case `${actions.LOAD_CONTACTS}_SUCCEEDED`:
      return {
        ...state,
        errors: {},
        contacts: action.payload.data,
      };

    case `${actions.LOAD_CONTACT_CARD}_SUCCEEDED`:
      return {
        ...state,
        errors: {},
        selectedContact: action.payload.data,
      };

    case `${actions.LOAD_CONTACTS}_FAILED`:
      let errors = { error: ["Server Error"]};

      try {
        errors = action.payload.response.data;
      } catch (err) {}

      return {...state, errors};

    case `${actions.ADD_CONTACT}_SUCCEEDED`:
      return {
        ...state,
      };

    case `${actions.DELETE_CONTACT}_SUCCEEDED`:
      return {
        ...state,
      };

    case `${actions.LOAD_CONTACT_INVITES}_SUCCEEDED`: {
      const invites = action.payload.data;
      const profileId = Number(getProfileId());

      return {
        ...state,
        errors: {},
        contactInvites: {
          received: [...invites.filter(invite => invite.target.id === profileId)],
          sent: [...invites.filter(invite => invite.creator.id === profileId)],
        },
      };
    }

    default:
      return state;
  }
}

export default contactsReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/contacts.reducer.js